<template>
  <n-modal
    v-model:show="isVisible"
    preset="card"
    title="Pedido actual"
    size="large"
    :style="{ maxWidth: '64rem', maxHeight: '90vh' }"
    :mask-closable="true"
    :close-on-esc="true"
  >
    <div
      v-if="!pedidoActual || !Object.keys(pedidoActual).length"
      class="p-6 text-center text-gray-500"
    >
      No hay pedido actual
    </div>
    <pre v-else class="p-4 bg-gray-50 rounded-md text-sm overflow-auto max-h-[70vh] font-mono">{{
      jsonDisplay
    }}</pre>
  </n-modal>
</template>

<script setup>
import { computed, ref } from "vue";
import { NModal } from "naive-ui";
import { useIndoStore } from "@/stores/indo";

const indoStore = useIndoStore();

const isVisible = ref(false);

const pedidoActual = computed(() => indoStore?.pedido);

const jsonDisplay = computed(() => {
  if (!pedidoActual.value) return "";
  try {
    return JSON.stringify(pedidoActual.value, null, 2);
  } catch {
    return String(pedidoActual.value);
  }
});

function show() {
  isVisible.value = true;
}

defineExpose({ show });
</script>
